import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  title: string;
  children: ReactNode;
}

export function BoxCta(props: Props) {
  return (
    <Root>
      <Title>{props.title}</Title>
      <Content>{props.children}</Content>
    </Root>
  );
}

const Root = styled.div`
  * + & {
    margin-top: 16px;
  }
`;

const Title = styled.p`
  ${getTextStyle({ size: 'xxs' })}
  font-weight: bold;
`;
const Content = styled.div`
  margin-top: 0.4em;
  ${getTextStyle({ size: 'xxs' })}
`;
